import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

function DomainDetails(props) {
  let domainDetails = props.domainDetails;
  let ownerDetailsContainer;
  let fleetOverviewContainer;

  ownerDetailsContainer = (
    <TableBody>
      <TableRow>
        <TableCell component="th" scope="row">
          Owner id
        </TableCell>
        <TableCell data-th="Owner id">
          {domainDetails.response.admin
            ? domainDetails.response.admin.user_id
            : "error"}
          {domainDetails.response.admin && (
            <Tooltip title="AlertAQ" arrow placement="top">
              <IconButton
                size="small"
                style={{ marginLeft: 5, padding: 1, verticalAlign: "middle" }}
                href={`https://alertaq.com/quickportal?tab=Users&qID=${domainDetails.response.admin.user_id}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open in AlertAQ"
              >
                <img src="/aq_logo.png" alt="AlertAQ" style={{ width: 16, height: 16, display: "block" }} />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell component="th" scope="row">
          Name
        </TableCell>
        <TableCell data-th="Name">
          {domainDetails.response.admin
            ? domainDetails.response.admin.first +
              " " +
              domainDetails.response.admin.last
            : "error"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell component="th" scope="row">
          Company
        </TableCell>
        <TableCell data-th="company">
          {domainDetails.response.company
            ? domainDetails.response.company
            : "Not Defined"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell component="th" scope="row">
          Email
        </TableCell>
        <TableCell data-th="email">
          {domainDetails.response.admin
            ? domainDetails.response.admin.email
            : "Not Defined"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell component="th" scope="row">
          Phone
        </TableCell>
        <TableCell data-th="email">
          {domainDetails.response.admin
            ? domainDetails.response.admin.phone
            : "Not Defined"}
        </TableCell>
      </TableRow>
    </TableBody>
  );
  fleetOverviewContainer = (
    <TableBody>
      <TableRow>
        <TableCell component="th" scope="row">
          Number of Locations
        </TableCell>
        <TableCell data-th="Number of Locations">
          {domainDetails.response.Locations
            ? domainDetails.response.Locations.length
            : "null"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell component="th" scope="row">
          Number of TeamMembers
        </TableCell>
        <TableCell data-th="Number of TeamMembers">
          {domainDetails.response.teamMembers
            ? domainDetails.response.teamMembers.length
            : "null"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell component="th" scope="row">
          Number of Sensors
        </TableCell>
        <TableCell data-th="Number of Sensors">
          {domainDetails.response.NumSensors
            ? domainDetails.response.NumSensors
            : "null"}
        </TableCell>
      </TableRow>
    </TableBody>
  );

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        {domainDetails.response.admin ? (
          <Grid item xs={12} md={12} lg={5}>
            <h3>Owner Details</h3>
            <Paper>
              <Table classes={{ root: "reactivetable" }}>
                {domainDetails.response.admin ? ownerDetailsContainer : null}
              </Table>
            </Paper>
          </Grid>
        ) : null}
        {domainDetails.response.admin ? (
          <Grid item xs={12} md={12} lg={5}>
            <h3>Fleet overview</h3>
            <Paper>
              <Table classes={{ root: "reactivetable" }}>
                {domainDetails.response.admin ? fleetOverviewContainer : null}
              </Table>
            </Paper>
          </Grid>
        ) : null}
      </Grid>
    </Container>
  );
}

export default DomainDetails;
